import React from 'react';
import {handleImageUrl} from "../../helpers";

const HomeTourItem = ({tour}) => {
    if (!tour) return null;
    const image = handleImageUrl(tour.thumbnail)
    return (
        <div className='home-tour-item'>
            {image && <img src={image} alt={tour.title}/>}
            <h3 className="title">{tour.title}</h3>
        </div>
    );
};

export default HomeTourItem;